import React from 'react';
import {api} from './services/api';
import secure from './config/secureLS';

interface Data {
    PKGrupo?: string,
    PKSegmento?: string,
    PKTransportadora?: string,
    PKUser?: string,
    boolCliente?: string,
    boolConcorrente?: string,
    boolEmpresaCobranca?: string,
    boolFaccao?: string,
    boolFornecedor?: string,
    boolFuncionario?: string,
    boolRepresentante?: string,
    boolTransportadora?: string,
    boolUserAtivo?: string,
    dtUsoarioAtualizou?: string,
    dtUsoarioUltimoAcesso?: string,
    iQtdeAcessos?: string,
    sCNPJ_CPF?: string,
    sCPF?: string,
    sCodigoCliente?: string,
    sDadosCadastrais?: string,
    sEmail?: string,
    sNome?: string,
    sNomeGrupo?: string,
    sNomeSegmento?: string,
    sRazaoCliente?: string
}

interface Props {

    login: null | boolean,
    userLogin: Function,
    data: Data,
    error: string,
    loading: boolean | null,
    userLogout: Function,
    setLoading: Function,

}

export const UserContext = React.createContext<Props>({
    userLogin: (email: string, password: string) => {
    },
    login: null,
    data: {},
    error: '',
    loading: null,
    userLogout: () => {
    },
    setLoading: (state: boolean) => {
    }
});

export const UserStorage: React.FC = ({children}) => {

    const [data, setData] = React.useState({});
    const [login, setLogin] = React.useState<boolean | null>(null);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');

    const userLogout = React.useCallback(async function () {
        setData({});
        setError('');
        setLoading(false);
        setLogin(false);

        secure.clear();
        // eslint-disable-next-line   
    }, []);

    React.useEffect(() => {
        async function autoLogin() {
            const token = secure.get('sultan@access-token');
            if (token) {
                try {
                    setError('');
                    setLoading(true);
                    const {data} = await api.get('user');

                    if (!data.status) throw new Error("Token Inválido.");

                    await getUser();
                } catch (error) {
                    userLogout();

                    const result = (error as Error).message;
                    setError(result);
                } finally {
                    setLoading(false);
                }
            } else {
                userLogout();
            }
        }

        autoLogin();
    }, [userLogout]);

    async function getUser() {
        try {
            const {data} = await api.get('user');

            setData(data.user);
            setLogin(true);
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        }
    }

    async function userLogin(email: string, password: string) {
        try {
            setError('');
            setLoading(true);

            const {data} = await api.post('auth/login', JSON.stringify({
                email,
                password
            }));

            secure.set('sultan@access-token', {data: data.token});
            await getUser();
        } catch (error) {
            setLogin(false);

            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    };

    return (
        <UserContext.Provider value={{
            userLogin,
            login,
            data,
            error,
            loading,
            userLogout,
            setLoading
        }}>
            {children}
        </UserContext.Provider>
    );

}